import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.css"],
})
export class ResetPasswordComponent implements OnInit {
  mobile: boolean = false;
  token: string = "";
  newPassword: string = "";
  confirmPassword: string = "";
  message: string = "";
  isSuccess: boolean = false;
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit() {
    // E-postadaki linkten gelen ?token=XYZ parametresini yakalıyoruz
    this.token = this.route.snapshot.queryParams["token"] || "";

    // 🛠️ 2. Yol: Angular 7 + Hash (#/) için Kesin Çözüm
    // Eğer Angular yönlendiricisi parametreyi kaçırırsa, tarayıcı URL'inden manuel cımbızlıyoruz
    if (!this.token) {
      const urlParts = window.location.href.split("token=");
      if (urlParts.length > 1) {
        this.token = urlParts[1];
      }
    }

    // Doğrulama Kontrolü
    if (!this.token) {
      this.message =
        "Geçersiz veya eksik şifre sıfırlama parametresi (Token bulunamadı).";
      this.isSuccess = false;
    } else {
      // Test amaçlı console'a yazdırıp token'ı görebilirsiniz
      console.log("Yakalayan Token:", this.token);
    }

    let mobileParam = this.route.snapshot.queryParams["mobile"];

    // 2. KESİN ÇÖZÜM: Eğer snapshot boş geldiyse (Hash yönlendirmesi yüzünden),
    // doğrudan tarayıcı URL'inden manuel cımbızla çekelim.
    if (!mobileParam) {
      const currentUrl = window.location.href;

      if (currentUrl.includes("?")) {
        // Soru işaretinden sonraki tüm parametre kümesini eksiksiz alıyoruz
        const queryString = currentUrl.substring(currentUrl.indexOf("?"));
        const urlParams = new URLSearchParams(queryString);

        if (urlParams.has("mobile")) {
          mobileParam = urlParams.get("mobile");
          this.mobile = mobileParam;
        }
      }
    } else this.mobile = mobileParam;

    if (this.mobile) {
      const lowerMobile = this.mobile.toString().trim().toLowerCase();

      // Eğer gelen değer 'false' ise bu bir mobil istek DEĞİLDİR, 'true' ise mobildir
      this.mobile = lowerMobile === "true";
    } else {
      this.mobile = false;
    }
  }

  submitNewPassword() {
    if (!this.newPassword || this.newPassword.length < 6) {
      this.message = "Şifre en az 6 karakter uzunluğunda olmalıdır.";
      this.isSuccess = false;
      return;
    }

    if (this.newPassword !== this.confirmPassword) {
      this.message = "Şifreler birbiriyle uyuşmuyor.";
      this.isSuccess = false;
      return;
    }

    this.isLoading = true;
    this.message = "";

    const obj = { token: this.token, newPassword: this.newPassword };
    this.authService.resetPassword(obj).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.isSuccess = true;

        if (!this.mobile) {
          this.message =
            "Şifreniz başarıyla güncellendi! Giriş sayfasına yönlendiriliyorsunuz...";
          setTimeout(() => this.router.navigate(["/login"]), 3000);
        } else
          this.message =
            " Şifreniz başarıyla güncellendi! Mobil uygulamanıza yeni şifrenizle giriş yapabilirsiniz.";
      },
      (err) => {
        this.isLoading = false;
        this.isSuccess = false;
        this.message =
          err.error && err.error.message
            ? err.error.message
            : "Linkin süresi dolmuş veya geçersiz bir işlem yapılmış olabilir.";
      },
    );
  }
}
